import { useContext, useEffect, useCallback } from "react";
import useActions from "./useactions";
import { ErrorsDisbatch } from "../contexts/errors";
import { SourcesValue } from "../contexts/sources";

export default function useElementErrors(
  workflow,
  localsources,
  getReturnSources
) {
  const { actions } = useActions();
  const disbatch = useContext(ErrorsDisbatch);
  const sources = useContext(SourcesValue);

  const checkWithSources = useCallback(
    (dynamicObject, actionIndex, sources) => {
      if (!dynamicObject[0]) {
        return true;
      }
      const validSource = [...sources, ...getReturnSources(actionIndex)].find(
        (x) => !!x && x.code === dynamicObject[0].value
      );

      return !!validSource;
    },
    [actions, sources]
  );

  const checkProps = useCallback(
    (action, schema, index, sources) => {
      const errors = [];
      schema.props.forEach((prop) => {
        const value = action.props[prop.name];
        if (!value && prop.required) {
          errors.push({
            actionId: action.id,
            actionName: action.name,
            actionError: `${prop.displayName} is a required prop`,
          });
        }
        if (Array.isArray(value)) {
          const dynamicValues = value.filter((x) => typeof x !== "string");
          const check = dynamicValues.every((x) => {
            return checkWithSources(x, index, sources);
          });

          if (!check) {
            errors.push({
              actionId: action.id,
              actionName: action.name,
              workflow: workflow.name,
              workflowId: workflow.id,
              actionError: `${prop.displayName} value is not valid`,
            });
          }
        }
      });

      return errors;
    },
    [sources, actions, checkWithSources]
  );

  const getActionErrors = useCallback(
    (action, index, sources) => {
      if (!actions) {
        return;
      }
      const schema = actions.find((x) => x.name === action.action);

      if (!schema) {
        return;
      }

      if (action.children) {
        action.children.forEach((child) => {
          child.actions.forEach((_action, _index) => {
            const _sources = [...sources, getReturnSources(index)];
            getActionErrors(_action, _index, _sources);
          });
        });
      }
      if (action.props) {
        const errors = checkProps(action, schema, index, sources);
        disbatch({
          type: "setErrorsForWorkflow",
          value: [...errors],
          actionId: action.id,
        });
      }
    },
    [actions, sources]
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!workflow) {
        return;
      }
      workflow.actions.map((action, index) => {
        return getActionErrors(action, index, [...sources, ...localsources]);
      });
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [workflow, actions, checkProps, sources]);
}
